<template>
  <section class="page-section bg-light">
    <div class="container">
      <div class="row align-items-center justify-content-center text-center">
        <div class="col-lg-10 align-self-end">
          <h1 class="text-uppercase text-black font-weight-bold">
            Your account is not yet activated
          </h1>
          <hr class="divider my-4" />
        </div>
      </div>
      <div class="align-items-center d-flex justify-content-center">
        <div style="text-align:center">
          <div class="float-right align-middle mr-2">
            <p class="m-0 p-0 loading-paragraph" v-if="!process[1]">
              Waiting for:
            </p>
            <p style="color:rgb(17, 168, 171)">
              Admin Verification
              <span v-if="process[1]" class="fas fa-check"> </span>

              <span
                v-if="!process[1]"
                rel="tooltip"
                title="Please wait for the website administrator to unlock your account"
                class="fas fa-question-circle "
                style="font-size:12px"
              ></span>
            </p>
          </div>
        </div>

        <div class="donut-chart-block block">
          <div class="donut-chart">
            <div
              id="part1"
              class="portion-block"
              :class="{
                part1_done: process[0],
                part1_start: !process[0]
              }"
            >
              <div class="circle"></div>
            </div>
            <div
              id="part2"
              class="portion-block"
              :class="{
                part2_done: process[1],
                part2_start: !process[1]
              }"
            >
              <div class="circle"></div>
            </div>
            <p class="center"></p>
          </div>
        </div>

        <div class="float-left ml-3">
          <div style="text-align:center">
            <p v-if="!process[0]" class="m-0 p-0 loading-paragraph">
              Waiting for:
            </p>
            <p style="color:rgb(230, 76, 101)">
              E-Mail Activation
              <span v-if="process[0]" class="fas fa-check"></span>
              <span
                v-if="!process[0]"
                rel="tooltip"
                title="Please click on the activation link that was sent to your e-mail"
                class="fas fa-question-circle "
                style="font-size:12px"
              ></span>
            </p>
          </div>
        </div>
      </div>
      <div class="row align-items-center justify-content-center text-center">
        <button class="btn  btn-primary" @click="$emit('login-again')">
          Go to Login
        </button>
      </div>
      <div
        class="row align-items-center justify-content-center text-center mt-2"
      >
        <button class="btn  btn-primary" @click="$emit('resendMail')">
          Resend Activation E-Mail
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["process", "resendMail"]
};
</script>

<style lang="scss">
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.donut-chart {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto 2rem;
  border-radius: 100%;
}

p.center {
  background: rgb(248, 249, 250);
  border: 1px solid grey;
  position: absolute;
  text-align: center;
  font-size: 28px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 130px;
  height: 130px;
  margin: auto;
  border-radius: 50%;
  line-height: 35px;
  padding: 15% 0 0;
}

.portion-block {
  border-radius: 50%;
  clip: rect(0px, 200px, 200px, 100px);
  border: 1px solid black;
  height: 100%;
  position: absolute;
  width: 100%;
}

.circle {
  border-radius: 50%;
  clip: rect(0px, 100px, 200px, 0px);
  height: 100%;
  position: absolute;
  width: 100%;
  font-family: monospace;
  font-size: 1.5rem;
}

#part1 {
  transform: rotate(0deg);
}

#part2 {
  transform: rotate(180deg);
}

.part2_start {
  transform: rotate(180deg);
  opacity: 0.5;
}

.part2_start .circle {
  transform: rotate(180deg);
  background-color: #11a8ab;
}

.part1_start {
  transform: rotate(180deg);
  opacity: 0.5;
}

.part1_start .circle {
  transform: rotate(180deg);
  background-color: #e64c65;
}

.part2_done .circle {
  background-color: #11a8ab;
  animation: second 1s 1 forwards 1s;
}

.part1_done .circle {
  background-color: #e64c65;
  animation: second 1s 1 forwards 1s;
}

/* Animation */
@keyframes first {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(180deg);
  }
}

@keyframes second {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(180deg);
  }
}
</style>
